import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { MUI_X_LICENSE_KEY } from './muiLicense';
import { BrowserRouter } from 'react-router-dom';
import type { EnvConfig } from './types/EnvConfig';
import AuthProvider from './providers/AuthProvider/AuthProvider';

// license is static across all environments, if we need to update
//  to be environment specific we can move this to App.tsx and leverage
//  EnvConfig context
LicenseInfo.setLicenseKey(MUI_X_LICENSE_KEY);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

void (async () => {
  try {
    const response = await fetch('/config.json');
    const envConfig = (await response.json()) as EnvConfig;

    root.render(
      <BrowserRouter>
        <AuthProvider projectId={envConfig.DESCOPE_PROJECT_ID}>
          <App />
        </AuthProvider>
      </BrowserRouter>,
    );
  } catch {
    root.render(<div>There was an error loading the environment configuration.</div>);
  }
})();
